import { GraphImageProp } from '@graphcms/react-image';

export interface GraphCmsSrcSet {
  srcSet:{
    w: number,
    h: number,
  }[],
  srcSetString: string,
  maxWidth: number,
  maxHeight: number,
  src: string,
  sizes: string,
}

const responsiveSizes = (size: number) => [
  size / 4,
  size / 2,
  size,
  size * 1.5,
  size * 2,
  size * 3,
];

export default function getGraphImageSrcSet(image:GraphImageProp, maxWidth: number): GraphCmsSrcSet {
  const imageProportion = image.width / image.height;
  const maxHeight = maxWidth / imageProportion;

  const srcSet = responsiveSizes(maxWidth)
    .filter((size) => size < image.width)
    .map((size) => ({ w: size, h: size / imageProportion }))
    .concat([{ w: image.width, h: image.height }]);

  return {
    srcSet,
    srcSetString: srcSet.map(
      (size) => `https://media.graphassets.com/resize=w:${size.w},fit:crop/auto_image/compress/${image.handle} ${Math.floor(size.w)}w`,
    ).join(',\n'),
    maxWidth,
    maxHeight,
    src: `https://media.graphassets.com/resize=w:${image.width},fit:crop/auto_image/compress/${image.handle}`,
    sizes: `(max-width: ${maxWidth}px) 100%, ${maxWidth}px`,
  };
}
